import { gql } from 'graphql-tag'

export default gql`
  fragment ModuleTerminalIntegrationSpecsFragment on ModuleTerminalIntegrationSpecs {
    terminalApi
    appIntegration
    androidApi
  }
`
